<template>
  <div>
    <div class="article-wrap">
      <article-detail-wrap
        v-for="(detail,index) in form.data.details"
        :key="`detail-${index}`"
        :detail="detail"
        @edit="editDetail(index)"
        @onUp="onDetailUp(index)"
        @onDown="onDetailDown(index)"
        @onRemove="onDetailRemove(index)">
      </article-detail-wrap>
    </div>
    <div style="width: 375px;margin: 0 auto;">
      <a-button type="dashed" block @click="addArticleDetail" style="margin-top: 20px">
        ADD
      </a-button>
      <a-button type="dashed" block @click="saveArticle" style="margin-top: 20px">
        SAVE
      </a-button>
    </div>
    <a-modal
      title="编辑"
      @ok="saveArticleDetail"
      @cancel="cancelArticleDetail"
      v-model="articleDetailForm.visible">
      <a-form-model
        v-if="articleDetailForm.visible"
        ref="articleForm"
        :model="articleDetailForm.data">
        <a-form-model-item
          v-if="!articleDetailForm.data.type"
          label="请选择分类">
          <dict-select
            v-model="articleDetailForm.data.type"
            dict-code="WEBSITE_ARTICLE_DETAIL_TYPE"/>
        </a-form-model-item>
        <a-form-model-item
          v-if="articleDetailForm.data.type === 'IMAGE'"
          label="图片">
          <simple-uploader-s3
            ref="detailImgUploader"
            v-model="articleDetailForm.data.image"/>
        </a-form-model-item>
        <a-form-model-item
          v-if="articleDetailForm.data.type === 'IMAGES'"
          label="图集">
          <multi-uploader-old
            ref="detailMultiImgUploader"
            v-model="articleDetailForm.data.images"/>
        </a-form-model-item>
        <a-form-model-item
          v-if="articleDetailForm.data.type === 'VIDEO'"
          label="视频">
          <simple-uploader-s3
            type="VIDEO"
            ref="detailVideoUploader"
            v-model="articleDetailForm.data.video"/>
        </a-form-model-item>
        <a-form-model-item
          v-if="articleDetailForm.data.type === 'IMAGES'"
          label="高度">
          <a-input v-model="articleDetailForm.data.imagesHeight"></a-input>
        </a-form-model-item>
        <a-form-model-item
          v-if="articleDetailForm.data.type === 'IMAGES'"
          label="宽度">
          <a-input v-model="articleDetailForm.data.imagesWidth"></a-input>
        </a-form-model-item>
        <!--        <a-form-model-item label="下外边距">-->
        <!--          <a-input-number v-model="articleDetailForm.data.containerStyle.marginBottom"></a-input-number>-->
        <!--        </a-form-model-item>-->
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { _queryArticleDetails, _saveArticle } from '@/api/websiteArticleApi';
import DictSelect from '@/components/DictSelect.vue';
import SimpleUploaderS3 from '@/components/SimpleUploaderS3.vue';
import ArticleDetailWrap from '@/components/websiteArticleDetail/WebsiteArticleDetailWrap.vue';
import MultiUploaderOld from '../MultiUploaderOld.vue';

async function getArticle() {
  const result = await _queryArticleDetails(this.entityType, this.entityId);
  if (result) {
    this.form.data.details = result.content.map(x => ({
      index: x.index,
      type: x.type,
      name: x.name,
      richText: x.richText,
      text: x.text,
      style: x.style,
      containerStyle: JSON.parse(x.containerStyle),
      images: x.images ? x.images.split('|') : [],
      image: x.image,
      video: x.video,
      title: x.title,
      subTitle: x.subTitle,
      description: x.description,
      targetId: x.targetId,
    }));
  }
}

async function saveArticle() {
  const data = this.form.data.details.map(x => ({
    ...x,
    images: x.images.join('|'),
    containerStyle: JSON.stringify(x.containerStyle),
  }));
  const result = await _saveArticle(this.entityType, this.entityId, data);
  if (result) {
    this.$message.success('更新成功');
  }
}

function reviewVideo() {
  if (this.form.data.videoPath) {
    this.video.visible = true;
  }
}

function addArticleDetail() {
  if (!this.articleDetailForm.visible) {
    this.articleDetailForm.visible = true;
  }
}

function saveArticleDetail() {
  if (this.articleDetailForm.data.type === 'IMAGE') {
    const style = this.$refs.detailImgUploader.getSize();
    this.articleDetailForm.data.style = JSON.stringify(style);
  }
  if (this.articleDetailForm.data.type === 'VIDEO') {
    const style = this.$refs.detailVideoUploader.getSize();
    this.articleDetailForm.data.style = JSON.stringify(style);
  }
  if (this.articleDetailForm.data.type === 'IMAGES') {
    const width = this.articleDetailForm.data.imagesWidth;
    const height = this.articleDetailForm.data.imagesHeight;
    const str = '{"width":' + width + ',"height":' + height + '}';
    this.articleDetailForm.data.style = str;
  }
  if (this.articleDetailForm.data.index != null) {
    this.form.data.details = [
      ...this.form.data.details.map(x => ({
        ...x,
      })),
    ];
  } else {
    this.form.data.details = [
      ...this.form.data.details.map(x => ({
        ...x,
      })),
      this.articleDetailForm.data,
    ];
  }
  this.articleDetailForm.data = {
    index: null,
    type: null,
    name: '',
    richText: '',
    text: '',
    style: '',
    containerStyle: {
      marginBottom: 5,
    },
    images: [],
    image: '',
    video: '',
    title: '',
    subTitle: '',
    description: '',
    targetId: '',
    targetType: '',
  };
  this.articleDetailForm.visible = false;
}

function cancelArticleDetail() {
  this.articleDetailForm.data = {
    index: null,
    type: null,
    name: '',
    richText: '',
    text: '',
    style: '',
    containerStyle: {
      marginBottom: 5,
    },
    images: [],
    image: '',
    video: '',
    title: '',
    subTitle: '',
    description: '',
    targetId: '',
    targetType: '',
  };
  this.articleDetailForm.visible = false;
}

function editDetail(index) {
  this.articleDetailForm.data = this.form.data.details[index];
  this.articleDetailForm.data.index = index;
  this.articleDetailForm.visible = true;
}

function onDetailUp(index) {
  console.log(index);
  if (index === 0) {
    return;
  }
  this.form.data.details.splice(index - 1, 0, (this.form.data.details[index]));
  this.form.data.details.splice(index + 1, 1);
  this.form.data.details = [...this.form.data.details];
}

function onDetailDown(index) {
  if (index === (this.form.data.details.length - 1)) {
    return;
  }
  // 在下一项插入该项
  this.form.data.details.splice(index + 2, 0, (this.form.data.details[index]));
  // 删除前一项.
  this.form.data.details.splice(index, 1);
  this.form.data.details = [...this.form.data.details];
}

function onDetailRemove(index) {
  this.form.data.details = this.form.data.details.filter((x, i) => i !== index);
}

export default {
  name: 'ArticleDetail',
  props: {
    entityType: String,
    entityId: String,
  },
  created() {
    this.getArticle();
  },
  components: {
    MultiUploaderOld,
    ArticleDetailWrap,
    SimpleUploaderS3,
    DictSelect,
  },
  methods: {
    getArticle,
    reviewVideo,
    addArticleDetail,
    saveArticleDetail,
    cancelArticleDetail,
    onDetailUp,
    onDetailDown,
    onDetailRemove,
    editDetail,
    saveArticle,
  },
  data() {
    return {
      arrStyle: [],
      video: {
        visible: false,
        url: '',
      },
      articleDetailForm: {
        visible: false,
        data: {
          index: null,
          type: null,
          name: '',
          richText: '',
          text: '',
          style: '',
          images: [],
          image: '',
          video: '',
          title: '',
          subTitle: '',
          description: '',
          targetId: '',
          containerStyle: {
            marginBottom: 5,
          },
          targetType: '',
          imagesHeight: '',
          imagesWidth: '',
        },
      },
      form: {
        data: {
          title: '',
          subTitle: '',
          description: '',
          type: '',
          coverPath: '',
          videoPath: '',
          jumpType: '',
          targetId: '',
          details: [],
        },
        rules: {
          title: [{
            required: true,
            trigger: 'blur',
          }],
          subTitle: [{
            required: true,
            trigger: 'blur',
          }],
          type: [{
            required: true,
            trigger: 'blur',
          }],
          coverPath: [{
            required: true,
            trigger: 'blur',
          }],
          videoPath: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    };
  },
};
</script>

<style scoped>

</style>
